import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";

import { GenericUploadRowConflictsContext } from "../../contexts";
import { RowConflictsExpanded } from "./row-conflicts-expanded";

export const RowConflictsTable: FC = () => {
  const { conflicts } = useContext(GenericUploadRowConflictsContext);
  const { t } = useTranslation();

  return (
    <RowConflictsExpanded>
      <ExpandedTable dataE2E="row-conflicts-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("general.index")}</TableCell>
              <TableCell>{t("general.field")}</TableCell>
              <TableCell>{t("general.value")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map((conflict, idx) => (
              <TableRow key={`${conflict.index}_${idx}`}>
                <TableCell>{conflict.index}</TableCell>
                <TableCell>{conflict.field || "-"}</TableCell>
                <TableCell>{conflict.fieldValue || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RowConflictsExpanded>
  );
};
